import { Injectable } from "@angular/core";
import { getKey } from "pax-ui/core";
import { concatMap, map, Observable } from "rxjs";

import { Gender } from "src/app/shared/store/quote/term-life-insurance/quote.state";
import { BaseStaticDataFormService } from "../../base-static-data-form.service";
import {
  OccupationDto,
  OccupationHttpService,
} from "./occupation-http.service";

// Note: Decision 24.07.23 - If there is no gender, we take the female label as default
@Injectable({
  providedIn: "root",
})
export class OccupationFormService extends BaseStaticDataFormService {
  readonly shareReplayOccupations$: Observable<OccupationDto[]>;

  constructor(private readonly _occupationService: OccupationHttpService) {
    super();
    this.shareReplayOccupations$ = this.initializeOccupationObservable();
  }

  static tryGetOccupationName(
    occupations: OccupationDto[],
    occupationId?: number,
    gender?: Gender,
  ) {
    const occupation = occupations.find(
      (occupationDto) => occupationDto.occupationId === occupationId,
    );

    return gender === Gender.MALE
      ? occupation?.labelMale
      : occupation?.labelFemale;
  }

  static getOccupationId(occupations: OccupationDto[], occupationName: string) {
    const occupationId = this.tryGetOccupationId(occupations, occupationName);

    if (!occupationId) {
      throw Error(
        `Can not find an occupation with the name '${occupationName}'`,
      );
    }

    return occupationId;
  }

  static tryGetOccupationId(
    occupations: OccupationDto[],
    occupationName: string,
  ) {
    const occupation = occupations.find(
      (occupation) =>
        occupation.labelFemale === occupationName ||
        occupation.labelMale === occupationName,
    );

    return occupation ? occupation.occupationId : undefined;
  }

  static getOccupationLabelIdentifier(gender?: Gender) {
    return gender === Gender.MALE
      ? getKey<OccupationDto>("labelMale")
      : getKey<OccupationDto>("labelFemale");
  }

  private initializeOccupationObservable() {
    return this.createDefaultHttpObservable().pipe(
      concatMap(() => this._occupationService.get()),
      map((response) => response.occupations),
      this.createShareReplayObservable(),
    );
  }
}
